import {ConfigProvider} from "antd";
import koKR from "antd/locale/ko_KR";
import React from "react";

type Props = {
  children: React.ReactNode;
};
export const AntProvider = ({children}: Props) => (<ConfigProvider
  locale={koKR}
  theme={{
    components: {
      Tag: {
        orange: "#ffd591", borderRadius: 2, colorInfoBg: "#FBFBFF", colorInfoBorder: "#E2E2FF", colorInfo: "#6E6EFF",
      }, Table: {
        colorPrimary: "#706EFF", cellFontSizeSM: 12, cellPaddingBlockSM: 2, borderRadiusSM: 2
      }, Input: {
        activeBg: "#fff", borderRadiusSM: 2, inputFontSizeSM: 13,
      }, Button: {
        defaultBg: "#fff", defaultHoverBg: "#fff",
      }, Drawer: {
        colorBgContainer: "#fff",
      }, Modal: {
        contentBg: 'var(--black-85)',
      }, Message: {
        contentBg: 'var(--black-85)',
      }, Progress: {
        circleTextColor: "transparent", defaultColor: "#fff",
      }, Menu: {
        darkItemBg: "#141E28", darkItemColor: "#fff", darkItemSelectedBg: "#FBFBFF", darkItemSelectedColor: "#6E6FFF", // darkSubMenuItemBg: "#FBFBFF",
        itemBorderRadius: 0, itemMarginInline: 0,
      }, Breadcrumb: {
        fontSize: 14, linkColor: 'var(--primary)'
      }, Slider: {
        // handleActiveOutlineColor: 'var(--highlight)',
        handleActiveColor: 'var(--highlight)',
        handleColor: 'var(--highlight)', // handleLineWidth: 1,
        handleSize: 10, // handleSizeHover: 10,
        dotSize: 4,
        railSize: 2,
        dotBorderColor: '#A0A0A0',
        dotActiveBorderColor: 'var(--highlight)',
        railBg: 'var(--greyd9)',
        trackBg: 'var(--highlight)',
        trackHoverBg: 'var(--highlight)',
      }
    }, token: {
      fontFamily: '"Spoqa Han Sans Neo", "Spoqa Han Sans KR"',
      borderRadius: 2,
      fontSizeSM: 12, // fontSize: 10,
      paddingXS: 4,
      borderRadiusLG: 12,
      colorBgBase: "#F0F2F5",
      controlHeightLG: 60,
      controlHeight: 42,
      controlHeightSM: 32, // Seed Token'
      colorPrimary: "#6e6eff",
      colorInfo: "#6e6eff",
      colorLink: "#5A5AFF", // Alias Token
      colorBgContainer: "#fff",
    },
  }}
>
  {children}
</ConfigProvider>);
